import React from 'react';

/**
 * Ask's mark: a hexagon in three facets round an empty centre. The top facet
 * is a lighter shade of the colour around it, the two side facets are the
 * colour itself, and the triangle between them is empty. Everywhere
 * Ask appears (the sidebar, the buttons that open it, the agent node that
 * calls it) uses this, so Ask never reads as a generic chat or sparkle icon.
 * Takes the same props as a lucide icon (size, className) and draws in the
 * colour around it (currentColor).
 *
 * Files for places that cannot render a component (an <img>, a favicon, a
 * deck): public/ask/ — ember, light, dark and tile versions, SVG and PNG.
 */
export const ASK_HOOD = 'M10.86 2.63 Q12.00 2.00 13.14 2.63 L19.96 6.41 Q20.40 6.65 19.97 6.91 L17.74 8.20 Q17.30 8.45 16.80 8.45 L7.20 8.45 Q6.70 8.45 6.26 8.20 L4.03 6.91 Q3.60 6.65 4.04 6.41 Z';
export const ASK_BODY = 'M3.21 7.85 Q3.20 7.35 3.63 7.60 L5.86 8.89 Q6.29 9.15 6.54 9.58 L11.35 17.97 Q11.60 18.40 11.60 18.90 L11.60 21.50 Q11.60 22.00 11.17 21.74 L4.51 17.68 Q3.40 17.00 3.37 15.70 Z M20.37 7.60 Q20.80 7.35 20.79 7.85 L20.63 15.70 Q20.60 17.00 19.49 17.68 L12.83 21.74 Q12.40 22.00 12.40 21.50 L12.40 18.90 Q12.40 18.40 12.65 17.97 L17.46 9.58 Q17.71 9.15 18.14 8.89 Z';
export const ASK_HOOD_OPACITY = 0.55;

const AskIcon = React.forwardRef(function AskIcon({ size = 16, className, style, 'aria-label': label, strokeWidth, absoluteStrokeWidth, ...rest }, ref) {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      style={style}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      {...rest}
    >
      <path d={ASK_HOOD} opacity={ASK_HOOD_OPACITY} />
      <path d={ASK_BODY} />
    </svg>
  );
});

export default AskIcon;
